<div *ngIf="descargas.length" class="descargas-cinta" role="status" aria-live="polite">
  <div *ngFor="let d of descargas; trackBy: trackClave" class="kb-card descargas-fila">
    <i class="fas fa-spinner fa-spin descargas-spinner" aria-hidden="true"></i>
    <div class="min-w-0">
      <div class="descargas-texto">{{ d.texto }}</div>
      <div class="descargas-ayuda">Puede tardar unos segundos. Puedes seguir usando la consola.</div>
    </div>
  </div>
</div>
